import { render, staticRenderFns } from "./prueba.vue?vue&type=template&id=afdafdf6&scoped=true&"
import script from "./prueba.vue?vue&type=script&lang=js&"
export * from "./prueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdafdf6",
  null
  
)

export default component.exports